<template>
  <div>
    <v-card outlined class="rounded-card">
      <div class="grey lighten-2">
        <px-aprovacao-compra-item-header @update="emitUpdate"
                                         :aprovacao="aprovacao"/>
      </div>
      <div>
        <px-aprovacao-compra-item-content @update="emitUpdate"
                                          :aprovacao="aprovacao"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import AprovacaoCompraItemHeader from '@/modules/aprovacao-compra/AprovacaoCompraItemHeader.vue';
import AprovacaoCompraItemContent from '@/modules/aprovacao-compra/AprovacaoCompraItemContent.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoCompraItemHeader: AprovacaoCompraItemHeader,
    pxAprovacaoCompraItemContent: AprovacaoCompraItemContent,
  },
};
</script>
